export { CustomHead as default } from './CustomHead'
